import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

const GetPerDiemEligibleUsersQuery = gql`
  query GetAllUsers{
    per_diem_eligible_users {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const userScope = querySelector(data, '$.per_diem_eligible_users.edges[*].node', []);
  return {
    data,
    ...ownProps,
    userScope,
  };
};

const queryGetPerDiemEligibleUsersData = graphql(GetPerDiemEligibleUsersQuery, { props: marshallData });

export const queryGetPerDiemEligibleUsersGQL = compose(
  queryGetPerDiemEligibleUsersData,
  queryMetaHandler,
  omitProps(['data']),
);
